import { useLayoutEffect, useRef, useState, type ReactNode } from 'react';
import { useLocation, useOutlet } from 'react-router-dom';
import { notifyRouteShown } from '../lib/route-activity';

/** Основные вкладки владельца: не размонтировать при переключении. */
export const OWNER_KEEP_ALIVE_PATHS = new Set([
  '/',
  '/inbox',
  '/money',
  '/bookings',
  '/objects',
  '/calendar',
  '/leads',
]);

export function KeepAliveOutlet() {
  const location = useLocation();
  const outlet = useOutlet();
  const path = location.pathname;
  const keep = OWNER_KEEP_ALIVE_PATHS.has(path);
  const [held, setHeld] = useState<Record<string, ReactNode>>({});
  const scrolls = useRef(new Map<string, number>());
  const prevPath = useRef(path);
  const shown = useRef(new Set<string>());

  useLayoutEffect(() => {
    if (!keep) return;
    setHeld((prev) => (prev[path] === outlet ? prev : { ...prev, [path]: outlet }));
  }, [keep, path, outlet]);

  useLayoutEffect(() => {
    if (!keep) return;
    if (!shown.current.has(path)) {
      shown.current.add(path);
      return;
    }
    notifyRouteShown(path);
  }, [keep, path]);

  useLayoutEffect(() => {
    const previous = prevPath.current;
    if (previous === path) return;
    const main = document.querySelector('.jack-owner-main');
    const scrollingMain = main instanceof HTMLElement && getComputedStyle(main).overflowY === 'auto';
    scrolls.current.set(previous, scrollingMain ? main.scrollTop : window.scrollY);
    prevPath.current = path;
    const next = keep ? (scrolls.current.get(path) ?? 0) : 0;
    if (scrollingMain) main.scrollTop = next;
    else window.scrollTo(0, next);
  }, [path, keep]);

  const nodes = keep ? { ...held, [path]: outlet } : held;

  return (
    <>
      {Object.entries(nodes).map(([cachedPath, node]) => (
        <div
          key={cachedPath}
          hidden={cachedPath !== path}
          {...(cachedPath !== path ? { inert: true } : {})}
        >
          {node}
        </div>
      ))}
      {keep ? null : outlet}
    </>
  );
}
